// export { default } from "./useSessionStorage";
import { useSessionStorage2 as useSessionStorage } from "./useSessionStorage2";

export default useSessionStorage;
